// Reusable confirm dialog — replaces native `window.confirm` calls
// with the dashboard's overlay aesthetic. Built on OverlayDialog so
// Escape / backdrop-click dismiss behavior is consistent with every
// other modal in the app. Use cases: delete confirmations, destructive
// edits, anywhere a yes/no with a clear primary action belongs.
//
// Pass `destructive` when the primary action is something the user
// would regret if accidentally clicked — flips the primary button to
// the red treatment so the eye lands on Cancel first.

import OverlayDialog from "./OverlayDialog.jsx";
import Button from "./ui/Button.jsx";
import { phAttrs } from "../lib/analytics/attrs.js";
import { ACTION, ATTRIBUTE } from "../lib/analytics/surfaceVocabulary.js";

export default function ConfirmDialog({
    open,
    title,
    body,
    eyebrow = "Confirm",
    confirmLabel = "Confirm",
    confirmDisabled = false,
    cancelLabel = "Cancel",
    destructive = false,
    onConfirm,
    onCancel,
    width = "440px",
    className = "",
    analyticsId = null,
}) {
    return (
        <OverlayDialog
            open={open}
            onClose={onCancel}
            eyebrow={eyebrow}
            title={title}
            width={width}
            className={className}
            analyticsId={analyticsId}
        >
            <div className="grid gap-[14px]">
                {body ? (
                    typeof body === "string" ? (
                        <p className="m-0 text-[13px] leading-[1.5] text-[color:var(--muted)]">{body}</p>
                    ) : (
                        body
                    )
                ) : null}
                <div className="flex items-center justify-end gap-[8px]">
                    <Button
                        onClick={onCancel}
                        data-confirm-dialog-cancel
                        {...phAttrs({ [ATTRIBUTE.ACTION]: ACTION.CANCEL })}
                    >
                        {cancelLabel}
                    </Button>
                    <Button
                        variant={destructive ? "danger" : "primary"}
                        onClick={onConfirm}
                        disabled={confirmDisabled}
                        autoFocus
                        data-confirm-dialog-primary
                        {...phAttrs({ [ATTRIBUTE.ACTION]: ACTION.CONFIRM })}
                    >
                        {confirmLabel}
                    </Button>
                </div>
            </div>
        </OverlayDialog>
    );
}
